import { useState } from 'react';

interface TikTokThumbnailProps {
  tiktokUrl: string;
  alt: string;
  className?: string;
  fallback?: string;
}

/**
 * TikTokのビデオIDからサムネイルURLを構築する
 * videoThumbnail（fallback）が設定されていればそれを優先して使用する
 */
export function useTikTokOembedThumbnail(tiktokUrl: string, fallback?: string) {
  const [src] = useState<string>(fallback || '');
  const ready = true;
  return { src, ready };
}

export default function TikTokThumbnail({ alt, className = '', fallback }: TikTokThumbnailProps) {
  const src = fallback || '';

  if (!src) {
    return (
      <div className={`${className} bg-gray-100 flex items-center justify-center`}>
        <i className="ri-image-line text-gray-400 text-2xl"></i>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
    />
  );
}
